var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.91231 11.4627C1.61545 11.7595 1.13416 11.7595 0.837305 11.4627C0.540452 11.1658 0.540452 10.6845 0.837305 10.3877L5.24981 5.9752L0.837304 1.56269C0.540451 1.26584 0.540452 0.784548 0.837305 0.487695C1.13416 0.190842 1.61545 0.190842 1.91231 0.487695L7.39981 5.9752L1.91231 11.4627Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.a233d1539150d1776b1b2ac1b07aaad2.svg";
export { ForwardRef as ReactComponent };